<button class="red-trash-can-button" [class]="class">
    <img src="assets/img/icons/trash.png" alt="Delete button">
</button>